export class Bundle {
    bundleID: string;
    bundleName: string;
    language: string;
    description: string;
}